__turbopack_context__.v({
  "link": "issuersCell-module-scss-module__FkWLLa__link",
  "links": "issuersCell-module-scss-module__FkWLLa__links",
  "tooltipContainer": "issuersCell-module-scss-module__FkWLLa__tooltipContainer",
});
